export default {"src":"/_next/static/media/soundcloud.3901068c.svg","height":64,"width":64,"blurWidth":0,"blurHeight":0};